// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Customer } from './customer';
import { QuoteLine } from './quote-line';
import { QuoteStatus } from './quote-status';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Quote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get statusName() {
    return this.status?.name;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billToAddress1?: string;
  billToAddress2?: string;
  billToCity?: string;
  billToContactName?: string;
  billToCountry?: string;
  billToEmail?: string;
  billToPhone?: string;
  billToState?: string;
  billToZip?: string;
  created!: Date;
  createdBy?: string;
  customerId?: number;
  deleted?: Date;
  deletedBy?: string;
  expirationDate!: Date;
  notes?: string;
  projectLocation?: string;
  projectName?: string;
  quoteCode?: string;
  quoteDate!: Date;
  quoteNumber!: number;
  shipTo?: string;
  statusId!: number;
  subTotal!: number;
  tax!: number;
  terms?: string;
  total!: number;
  customer!: Customer;
  quoteLines!: QuoteLine[];
  status!: QuoteStatus;
}

